/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamDocumentType } from './PamDocumentType';
import {
    PamDocumentTypeFromJSON,
    PamDocumentTypeFromJSONTyped,
    PamDocumentTypeToJSON,
} from './PamDocumentType';

/**
 * Metadata for one active document. Bytes are NOT included (fetched separately).
 * @export
 * @interface PamDocumentSummary
 */
export interface PamDocumentSummary {
    /**
     * 
     * @type {Date}
     * @memberof PamDocumentSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    uploadedBy: string;
    /**
     * 
     * @type {number}
     * @memberof PamDocumentSummary
     */
    byteSize: number;
    /**
     * Player-selected category (null for staff uploads / pre-migration rows).
     * @type {PamDocumentType}
     * @memberof PamDocumentSummary
     */
    documentType: PamDocumentType | null;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    fileName: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PamDocumentSummary
     */
    id: string;
}



/**
 * Check if a given object implements the PamDocumentSummary interface.
 */
export function instanceOfPamDocumentSummary(value: object): value is PamDocumentSummary {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined) return false;
    if (!('byteSize' in value) || value['byteSize'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PamDocumentSummaryFromJSON(json: any): PamDocumentSummary {
    return PamDocumentSummaryFromJSONTyped(json, false);
}

export function PamDocumentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'uploadedBy': json['uploadedBy'],
        'byteSize': json['byteSize'],
        'documentType': PamDocumentTypeFromJSON(json['documentType']),
        'contentType': json['contentType'],
        'fileName': json['fileName'],
        'id': json['id'],
    };
}

export function PamDocumentSummaryToJSON(value?: PamDocumentSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'uploadedBy': value['uploadedBy'],
        'byteSize': value['byteSize'],
        'documentType': PamDocumentTypeToJSON(value['documentType']),
        'contentType': value['contentType'],
        'fileName': value['fileName'],
        'id': value['id'],
    };
}

